var map = {
	"./a11yhelp/dialogs/lang/en.js": 3775,
	"./a11yhelp/dialogs/lang/hu.js": 4455,
	"./specialchar/dialogs/lang/en.js": 6755,
	"./specialchar/dialogs/lang/hu.js": 3475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8977;